import CommercialStagingForm from "./CommercialStagingForm"

const VirtualStagingForm = () => {
    return (
        <CommercialStagingForm unitPrice={16} form_name="Virtual Staging" />
    )
}

export default VirtualStagingForm;